var _path, _path2, _path3, _path4, _path5, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCylinderReturn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "flogas-icon flogas-icon--background",
    fill: "#E0F1F8",
    d: "M10,12c-3.3,0-6,2.7-6,6h8v-6H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "flogas-icon flogas-icon--background",
    fill: "#E0F1F8",
    d: "M4,52c0,1.1,0.9,2,2,2h6V22H4V52z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "flogas-icon flogas-icon--background",
    fill: "#E0F1F8",
    d: "M34,30c-0.7,0-1.4,0.1-2,0.4c-0.7,0.3-1.4,0.7-2,1.2c-0.7,0.7-1.3,1.5-1.6,2.5H36v-4L34,30L34,30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "flogas-icon flogas-icon--background",
    fill: "#E0F1F8",
    d: "M28,52c0,0.9,0.6,1.7,1.5,1.9C29.7,54,29.8,54,30,54h1.6l0,0c0.1,0,0.3,0,0.4,0h4V38h-8V52z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "flogas-icon flogas-icon--foreground",
    fill: "#4C2177",
    d: "M50,26.8V18H32c0-4.1-2.5-7.6-6-9.2V0H6v8.8C5.3,9.1,4.6,9.5,4,10c-0.8,0.6-1.5,1.3-2,2c-1.3,1.7-2,3.7-2,6 v34c0,2.1,1.1,4,2.8,5.1C2.3,57.9,2,58.9,2,60v4h52v-4c0-1.1-0.3-2.1-0.8-2.9c1.7-1.1,2.8-3,2.8-5.1V36 C56,31.9,53.5,28.4,50,26.8z M34,22h4c0,1.1,0.9,2,2,2s2-0.9,2-2h4v4H34V22z M10,4h4c0,1.1,0.9,2,2,2s2-0.9,2-2h4v4H10V4z M6,60 c0-1.1,0.9-2,2-2h16c1.1,0,2,0.9,2,2H6z M24,36v16c0,0.7,0.1,1.4,0.4,2H6c-1.1,0-2-0.9-2-2V22h14c1.1,0,2-0.9,2-2s-0.9-2-2-2H4 c0-3.3,2.7-6,6-6h12c3.3,0,6,2.7,6,6v10C25.6,29.8,24,32.7,24,36z M30,60c0-1.1,0.9-2,2-2h16c1.1,0,2,0.9,2,2H30z M52,52 c0,1.1-0.9,2-2,2H30c-0.2,0-0.3,0-0.5-0.1c-0.9-0.2-1.5-1-1.5-1.9V38h14c1.1,0,2-0.9,2-2s-0.9-2-2-2H28.4c0.3-1,0.9-1.8,1.6-2.5 c0.6-0.5,1.3-0.9,2-1.2c0.6-0.2,1.3-0.4,2-0.4h12c3.3,0,6,2.7,6,6V52z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "flogas-icon flogas-icon--foreground",
    fill: "#4C2177",
    points: "52,8.6 52,11.6 40,11.5 40,14 32,10 40,6 40,8.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "flogas-icon flogas-icon--foreground",
    fill: "#4C2177",
    points: "42.8,5.4 42.8,2.4 54.8,2.5 54.8,0 62.8,4 54.8,8 54.8,5.5 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCylinderReturn);
export default __webpack_public_path__ + "static/media/cylinder-return.c11e55877d228f8099db1d553ec0d786.svg";
export { ForwardRef as ReactComponent };